import { Navigate, useParams } from 'react-router-dom';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import CatalogRoutes from './CatalogRoutes';
import CatalogsPage from './CatalogsPage';
import CatalogFormPage from './CatalogFormPage';
import TemplatesPage from './pages/TemplatesPage';
import TemplateEditorPage from './pages/TemplateEditorPage';
import CatalogSettingsPage from './pages/CatalogSettingsPage';
import TemplateFileEditorPage from './pages/TemplateFileEditorPage';

const RedirectLayoutsToTemplates = () => <Navigate to="/catalogs/templates" replace />;

const RedirectLayoutEditToTemplateEdit = () => {
  const { id } = useParams();
  return <Navigate to={`/catalogs/templates/${id}/edit`} replace />;
};

const manifest = {
  id: 'catalog',
  nameKey: 'extensions.catalog.name',
  descriptionKey: 'extensions.catalog.description',
  icon: MenuBookOutlinedIcon,
  route: '/catalogs',
  menuItem: {
    labelKey: 'catalog.menu',
    basePath: '/catalogs',
    children: [
      { labelKey: 'catalog.menu_list', path: '/catalogs', end: true },
      { labelKey: 'catalog.templates.menu', path: '/catalogs/templates' },
      { labelKey: 'catalog.settings.menu', path: '/catalogs/settings' },
    ],
  },
  nestedRoutes: {
    Layout: CatalogRoutes,
    routes: [
      { index: true, Component: CatalogsPage, titleKey: 'catalog.menu_list' },
      { path: 'new', Component: CatalogFormPage, titleKey: 'catalog.create' },
      { path: 'settings', Component: CatalogSettingsPage, titleKey: 'catalog.settings.menu' },
      { path: 'templates', Component: TemplatesPage, titleKey: 'catalog.templates.menu' },
      { path: 'templates/new', Component: TemplateEditorPage, titleKey: 'catalog.templates.create' },
      { path: 'templates/edit-files', Component: TemplateFileEditorPage, titleKey: 'catalog.templates.edit_file' },
      { path: 'templates/:id/edit', Component: TemplateEditorPage, titleKey: 'catalog.templates.edit' },
      { path: 'layouts', Component: RedirectLayoutsToTemplates, titleKey: 'catalog.templates.menu' },
      { path: 'layouts/new', Component: () => <Navigate to="/catalogs/templates/new" replace />, titleKey: 'catalog.templates.create' },
      { path: 'layouts/:id/edit', Component: RedirectLayoutEditToTemplateEdit, titleKey: 'catalog.templates.edit' },
      { path: ':id/edit', Component: CatalogFormPage, titleKey: 'catalog.edit' },
    ],
  },
  requiredExtensions: [],
  Page: CatalogsPage,
};

export default manifest;
